import { render, staticRenderFns } from "./Detect.vue?vue&type=template&id=59c7bede"
import script from "./Detect.vue?vue&type=script&lang=js"
export * from "./Detect.vue?vue&type=script&lang=js"
import style0 from "./Detect.vue?vue&type=style&index=0&id=59c7bede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports